import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "pt-0 pb-8 text-3xl font-extrabold max-w-3xl" }, " Jamba powered by Uniti has merged with its parent company, Uniti Internet effective 27 March 2024. ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "font-bold text-xl" }, [
  /*#__PURE__*/_createTextVNode(" Jamba customers can login to the "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "underline",
    href: "https://my.unitiinternet.com/"
  }, "Uniti Internet customer portal"),
  /*#__PURE__*/_createTextVNode(" using your existing Jamba login details. ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "font-bold text-xl pt-2" }, [
  /*#__PURE__*/_createTextVNode(" You will be redirected to Uniti Internet in 20 seconds or "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "underline",
    href: "https://unitiinternet.com?from=jam"
  }, "click here.")
], -1)

import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import router from '@/router';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import { Brand } from '@/services/integration/enums';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

// Data.
// Event handlers.
const unitiRedirect = async () => {
  if (brandService.getName() === Brand.JAM) {
    setTimeout(() => {
      window.location.href = 'https://unitiinternet.com?from=jam';
    }, 22000);
  } else {
    router.push('/');
  }
};

unitiRedirect();

return (_ctx: any,_cache: any) => {
  const _component_Container = _resolveComponent("Container")!

  return (_openBlock(), _createBlock(_component_Container, {
    style: {"height":"80vh"},
    class: "bg-white h-screen text-center py-10 justify-center items-center flex flex-col px-4"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3
    ]),
    _: 1
  }))
}
}

})